<template>
    <div id="changepassword">
        <img src="../../assets/logo/アプリアイコン_黄グラデ_R1_収集しマース.png" fluid style="height:100px" class="m-5">
        <div>
            <div class="fromSection">
                <div class="sectionHeader">
                    パスワード変更
                </div>
                <div class="setionBody">
                    <b-form-group>
                        <div class="inputLabel">現パスワード</div>
                        <b-form-input id="current_password" v-model="l_current_password" placeholder="パスワード入力"
                            type="password" />
                        <div class="inputLabel">新パスワード</div>
                        <b-form-input id="new_password" v-model="l_new_password" placeholder="パスワード入力"
                            type="password" />
                        <div class="inputLabel">新パスワード（確認用）</div>
                        <b-form-input id="new_password_check" v-model="l_new_password_check" placeholder="パスワード入力"
                            type="password" />
                        <div class="buttonArea">
                            <div class="buttonLabel"> <b-button class="mypage-button"
                                    v-on:click="changePassword">パスワード変更</b-button>
                            </div>
                            <div class="buttonLabel"> <b-button class="mypage-button"
                                    v-on:click="backPasswordPage(1)">中止する</b-button>
                            </div>
                        </div>
                        <div class="errorLabel"> {{ l_error_message }}
                        </div>
                    </b-form-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Auth } from 'aws-amplify'

const SUCCESS_PASSWORD_MESSAGE = "パスワードが変更されました。"
const FAILURE_CURRENT_PASSWORD_MESSAGE = "現パスワードが間違ってます。"
const FAILURE_NEW_PASSWORD_MESSAGE = "新パスワードが一致しません。"
const FAILURE_MATCH_PASSWORD_MESSAGE = "新パスワードは現パスワードと別にしてください。"
const FAILURE_BREACH_PASSWORD_MESSAGE = "パスワードは英字数字含む6文字以上20文字以下でなければなりません。"
const NUMBER_REGEX = /[0-9]/g;
const CHARA_REGEX = /[A-Z]/gi;
export default {
    props: {
        handleClosePassword: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            l_current_password: "",
            l_new_password: "",
            l_new_password_check: "",
            l_error_message: "",
        }
    },
    // Initialized Event & Lifecycle
    beforeCreate() {
    },
    // Initialized Injection & Reactivity
    created() {
    },
    // Processed the following
    beforeMount() {
        // 1.Has "el" option?
        //   Yes  -> No action
        //   No   -> vm.&mount(el) is called.
        // 2.Has "template" option?
        //   Yes  -> Compile template into render function.
        //   No   -> Compile el's outerHTML as template
    },
    // Created vm.$el and replaced "el" with it.
    mounted() {
    },
    // Data changed in mounted state.
    beforeUpdate() {
    },
    // Virtual DOM re-rendered and patched in mounted state.
    updated() {
    },
    // vm.$destroy() is called.
    beforeUnmount() {
    },
    // Teardown completed watchers, child components and event listeners
    unmounted() {
    },
    computed: {
        // Getter of ...
    },
    watch: {
    },
    methods: {
        async changePassword() {
            if (this.checkPassword()) {
                const user = await Auth.currentAuthenticatedUser() // ログイン中のユーザー情報
                await Auth.changePassword(
                    user,
                    this.l_current_password, // 現在のパスワード
                    this.l_new_password  // 新しいパスワード
                )
                    .then((data) => {
                        this.backPasswordPage(0)
                    })
                    .catch((err) => {
                        this.l_error_message = FAILURE_CURRENT_PASSWORD_MESSAGE
                    })
            }
        },
        backPasswordPage(susccesflg) {
            this.handleClosePassword(susccesflg)
        },
        checkPassword() {
            if (this.l_new_password !== this.l_new_password_check) {
                this.l_error_message = FAILURE_NEW_PASSWORD_MESSAGE
                return false
            }

            if (this.l_current_password == this.l_new_password) {
                this.l_error_message = FAILURE_MATCH_PASSWORD_MESSAGE
                return false
            }
            if (this.l_new_password.length < 6 || this.l_new_password.length > 20) {
                this.l_error_message = FAILURE_BREACH_PASSWORD_MESSAGE
                return false
            }
            if (this.l_new_password.match(CHARA_REGEX) == null) {
                this.l_error_message = FAILURE_BREACH_PASSWORD_MESSAGE
                return false
            }
            if (this.l_new_password.match(NUMBER_REGEX) == null) {
                this.l_error_message = FAILURE_BREACH_PASSWORD_MESSAGE
                return false
            }
            return true
        },
    }
}
</script>
<style scoped>
#changepassword {
    text-align: center;
    white-space: pre-line;
}

.fromSection {
    text-align: left;
    padding: 35px 40px;
    display: inline-block;
    min-width: 460px;
}

.sectionHeader {
    margin-bottom: 24px;
    font-size: 18px;
    font-weight: 500;
}

.inputLabel {
    font-size: 14px;
    margin-bottom: 8px;
}

.buttonLabel {
    font-size: 14px;
    margin-bottom: 8px;
    text-align: right;
}

.form-control {
    display: block;
    width: 100%;
    padding: 16px;
    font-size: 14px;
    border: 1px solid var(--lightGrey);
    border-radius: 3px;
    box-sizing: border-box;
    margin-bottom: 10px;
}
</style>
